var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M63.5 6C31.1908 6 5 32.1913 5 64.5C5 96.8087 31.1908 123 63.5 123C95.8092 123 122 96.8087 122 64.5C122 32.1913 95.8092 6 63.5 6ZM12.5484 64.5C12.5484 36.3601 35.3594 13.5484 63.5 13.5484C91.6406 13.5484 114.452 36.3601 114.452 64.5C114.452 92.6399 91.6406 115.452 63.5 115.452C35.3594 115.452 12.5484 92.6399 12.5484 64.5Z","fill":"#333333","key":0}),React.createElement("path",{"d":"M67.1266 24.871C67.1266 22.7865 65.4367 21.0968 63.3524 21.0968C61.2681 21.0968 59.5782 22.7865 59.5782 24.871V64.3233H38.9676C36.8833 64.3233 35.1934 66.013 35.1934 68.0975C35.1934 70.1818 36.8833 71.8717 38.9676 71.8717H67.1266V24.871Z","fill":"#333333","key":1})]);
}

Clock.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none"};

module.exports = Clock;

Clock.default = Clock;
